import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['cardPaymentForm', 'submitButton', 'errorElement'];
  static values = {
    stripePublicKey: String,
    stripeClientSecretKey: String,
    successUrl: String,
    defaultSubmitText: String,
    countryCode: String,
  };

  connect() {
    this.stripe = Stripe(this.stripePublicKeyValue, {
      locale: 'auto',
    });
    this.openModal();
    this.mountElement();
  }

  openModal() {
    this.modal = new bootstrap.Modal(this.element);
    this.modal.show();
  }

  mountElement() {
    const appearance = {
      theme: 'stripe',
      labels: 'floating',
      rules: {
        '.Input': {
          borderColor: '#D0D5DD',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderRadius: '3.5px',
        },
        '.Input--invalid': {
          borderColor: '#CC3A3A',
          borderWidth: '1px',
          boxShadow: 'unset',
        },
      },
    };

    this.paymentElements = this.stripe.elements({
      clientSecret: this.stripeClientSecretKeyValue,
      appearance,
    });

    this.paymentElement = this.paymentElements.create(
      'payment',
      this.paymentElementOptions()
    );
    this.paymentElement.mount(this.cardPaymentFormTarget);
  }

  submit() {
    this.submitButtonTarget.disabled = true;
    this.submitButtonTarget.textContent =
      this.submitButtonTarget.dataset.disableWith;
    this.errorElementTarget.classList.add('d-none');

    this.stripe
      .confirmPayment({
        elements: this.paymentElements,
        confirmParams: {
          return_url: this.successUrlValue,
          payment_method_data: {
            billing_details: {
              address: {
                country: this.countryCodeValue,
              },
            },
          },
        },
      })
      .then((result) => {
        window.setTimeout(() => {
          this.submitButtonTarget.textContent = this.defaultSubmitTextValue;
          this.submitButtonTarget.disabled = false;
        }, 350);

        if (!!result.error) {
          console.error(result.error);
          this.errorElementTarget.textContent = result.error.message;
          this.errorElementTarget.classList.remove('d-none');
        }
      });
  }

  paymentElementOptions() {
    return {
      fields: {
        billingDetails: {
          address: {
            country: 'never',
          },
        },
      },
    };
  }
}
